import state from './moduloHerramientasState';
import mutations from './moduloHerramientasMutations';
import actions from './moduloHerramientasActions';
import getters from './moduloHerramientasGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
